var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "acea-row" }, [
            _c(
              "div",
              { staticClass: "tab_view" },
              _vm._l(_vm.tabList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "cell_item",
                    class: { tab_active: _vm.listActive === index },
                    on: {
                      click: function ($event) {
                        return _vm.ProductNavTab(index)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item) + " ")]
                )
              }),
              0
            ),
            _vm.listActive === 0
              ? _c("div", { staticClass: "rightModel acea-row" }, [
                  _c("div", { staticClass: "leftModel" }, [
                    _c("div", { staticClass: "current_home" }, [
                      _c("div", { staticClass: "model_header" }, [
                        _c("iframe", {
                          ref: "iframe",
                          staticClass: "iframe-box",
                          attrs: {
                            id: "iframe",
                            src: _vm.frontDomain,
                            frameborder: "0",
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "mask" }),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticStyle: { width: "100%" } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", _vm._b({}, "el-col", _vm.grid, false), [
                            _c(
                              "div",
                              { staticClass: "flex_between" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: [
                                          "platform:pagediy:update",
                                          "platform:pagediy:getdefault",
                                          "platform:pagediy:info",
                                        ],
                                        expression:
                                          "['platform:pagediy:update', 'platform:pagediy:getdefault', 'platform:pagediy:info']",
                                      },
                                    ],
                                    staticClass: "mb35",
                                    staticStyle: { "font-size": "12px" },
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlerDiyHomePage()
                                      },
                                    },
                                  },
                                  [_vm._v("首页装修")]
                                ),
                                _c(
                                  "el-card",
                                  {
                                    staticClass: "mb20 Qrcode-card",
                                    attrs: {
                                      "body-style":
                                        "background-color: #F9F9F9;",
                                      shadow: "never",
                                      bordered: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          _vm._b(
                                            {},
                                            "el-col",
                                            _vm.grid2,
                                            false
                                          ),
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "acea-row row-between-wrapper Qrcode-box",
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "title mb20",
                                                    },
                                                    [_vm._v("微信小程序")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "tips" },
                                                    [
                                                      _vm._v(
                                                        "扫描右侧二维码查看"
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-col",
                                          _vm._b(
                                            {},
                                            "el-col",
                                            _vm.grid2,
                                            false
                                          ),
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                              },
                                              [
                                                _c("el-image", {
                                                  staticClass: "Qrcode_img",
                                                  attrs: { src: _vm.Qrcode },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-card",
                                  {
                                    staticClass: "Qrcode-card",
                                    attrs: {
                                      "body-style":
                                        "background-color: #F9F9F9;",
                                      shadow: "never",
                                      bordered: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          _vm._b(
                                            {},
                                            "el-col",
                                            _vm.grid2,
                                            false
                                          ),
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "acea-row row-between-wrapper Qrcode-box",
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "title mb20",
                                                    },
                                                    [_vm._v("微信公众号")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "tips" },
                                                    [
                                                      _vm._v(
                                                        "扫描右侧二维码查看"
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-col",
                                          _vm._b(
                                            {},
                                            "el-col",
                                            _vm.grid2,
                                            false
                                          ),
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "acea-row",
                                                staticStyle: {
                                                  "justify-content": "right",
                                                },
                                              },
                                              [
                                                _c("div", {
                                                  attrs: { id: "diyQrcode" },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _c(
                  "div",
                  { staticClass: "rightModel" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "clearfix mb20",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["platform:pagediy:list"],
                                expression: "['platform:pagediy:list']",
                              },
                            ],
                            staticClass: "container",
                          },
                          [
                            _c(
                              "el-form",
                              {
                                attrs: { size: "small", inline: "" },
                                nativeOn: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "模板名称：" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请输入模板名称",
                                        clearable: "",
                                      },
                                      nativeOn: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.getList(1)
                                        },
                                      },
                                      model: {
                                        value: _vm.name,
                                        callback: function ($$v) {
                                          _vm.name =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getList(1)
                                          },
                                        },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["platform:pagediy:save"],
                                expression: "['platform:pagediy:save']",
                              },
                            ],
                            staticStyle: { "font-size": "12px" },
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerEditDiyPage(0, "add")
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus",
                              staticStyle: { "margin-right": "4px" },
                            }),
                            _vm._v("添加"),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["platform:pagediy:list"],
                                expression: "['platform:pagediy:list']",
                              },
                            ],
                            staticStyle: { "font-size": "12px" },
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.getList(1)
                              },
                            },
                          },
                          [_vm._v("刷新")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.listLoading,
                            expression: "listLoading",
                          },
                        ],
                        staticClass: "table",
                        attrs: {
                          data: _vm.tableData.data,
                          size: "small",
                          "highlight-current-row": "",
                          "cell-class-name": _vm.tableCellClassName,
                        },
                        on: { "row-dblclick": _vm.handleName },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "id", label: "ID", width: "50" },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "模板名称",
                            prop: "name",
                            "min-width": "210",
                            "show-overflow-tooltip": true,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "acea-row row-middle" },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: scope.row.isDefault === 1,
                                              expression:
                                                "scope.row.isDefault === 1",
                                            },
                                          ],
                                          staticClass: "mr5",
                                          attrs: { effect: "plain" },
                                        },
                                        [_vm._v("首页")]
                                      ),
                                      _c(
                                        "el-tag",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                scope.row.isTxcoverid === 1,
                                              expression:
                                                "scope.row.isTxcoverid === 1",
                                            },
                                          ],
                                          staticClass: "mr5",
                                          attrs: { effect: "plain" },
                                        },
                                        [_vm._v("视界")]
                                      ),
                                      _c(
                                        "el-tag",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: scope.row.isGoodsid === 1,
                                              expression:
                                                "scope.row.isGoodsid === 1",
                                            },
                                          ],
                                          staticClass: "mr5",
                                          attrs: { effect: "plain" },
                                        },
                                        [_vm._v("购物")]
                                      ),
                                      scope.row.index +
                                        "," +
                                        scope.column.index ==
                                        _vm.currentCell &&
                                      _vm.checkPermi([
                                        "platform:pagediy:updatename",
                                      ])
                                        ? _c("el-input", {
                                            ref:
                                              scope.row.index +
                                              "," +
                                              scope.column.index,
                                            attrs: {
                                              size: "mini",
                                              maxlength: "15",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.hideInput(scope.row)
                                              },
                                            },
                                            model: {
                                              value: scope.row.name,
                                              callback: function ($$v) {
                                                _vm.$set(scope.row, "name", $$v)
                                              },
                                              expression: "scope.row.name",
                                            },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "line1",
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                            },
                                            [_vm._v(_vm._s(scope.row.name))]
                                          ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "addTime",
                            label: "添加时间",
                            "min-width": "180",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "updateTime",
                            label: "更新时间",
                            "min-width": "180",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            width: "190",
                            fixed: "right",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            "platform:pagediy:update",
                                            "platform:pagediy:info",
                                          ],
                                          expression:
                                            "['platform:pagediy:update', 'platform:pagediy:info']",
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlerEditDiyPage(
                                            scope.row.id,
                                            "edit"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("设计")]
                                  ),
                                  _c("el-divider", {
                                    attrs: { direction: "vertical" },
                                  }),
                                  scope.row.isDefault !== 1 &&
                                  scope.row.isTxcoverid !== 1 &&
                                  scope.row.isGoodsid !== 1 &&
                                  _vm.checkPermi([
                                    "platform:pagediy:setdefault",
                                  ])
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.setHomepage(
                                                  scope.row.id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("设为首页")]
                                        ),
                                        _c("el-divider", {
                                          attrs: { direction: "vertical" },
                                        }),
                                      ]
                                    : _vm._e(),
                                  scope.row.isDefault !== 1 &&
                                  scope.row.isTxcoverid !== 1 &&
                                  scope.row.isGoodsid !== 1 &&
                                  _vm.checkPermi([
                                    "platform:pagediy:setdefault",
                                  ])
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.setTxcoverpage(
                                                  scope.row.id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("设为添星视界")]
                                        ),
                                        _c("el-divider", {
                                          attrs: { direction: "vertical" },
                                        }),
                                      ]
                                    : _vm._e(),
                                  scope.row.isDefault !== 1 &&
                                  scope.row.isTxcoverid !== 1 &&
                                  scope.row.isGoodsid !== 1 &&
                                  _vm.checkPermi([
                                    "platform:pagediy:setdefault",
                                  ])
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.setGoodsidpage(
                                                  scope.row.id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("设为购物页")]
                                        ),
                                        _c("el-divider", {
                                          attrs: { direction: "vertical" },
                                        }),
                                      ]
                                    : _vm._e(),
                                  _c(
                                    "el-dropdown",
                                    { attrs: { trigger: "click" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "el-dropdown-link" },
                                        [
                                          _vm._v(" 更多"),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-arrow-down el-icon--right",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown",
                                        },
                                        [
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              directives: [
                                                {
                                                  name: "hasPermi",
                                                  rawName: "v-hasPermi",
                                                  value: [
                                                    "platform:pagediy:save",
                                                    "platform:pagediy:info",
                                                  ],
                                                  expression:
                                                    "['platform:pagediy:save', 'platform:pagediy:info']",
                                                },
                                              ],
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.handlerEditDiyPage(
                                                    scope.row.id,
                                                    "copy"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("复制")]
                                          ),
                                          scope.row.isDefault !== 1 &&
                                          scope.row.isTxcoverid !== 1 &&
                                          scope.row.isGoodsid !== 1 &&
                                          _vm.checkPermi([
                                            "platform:pagediy:delete",
                                          ])
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.handleDelete(
                                                        scope.row.id,
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.previewProtol(
                                                    scope.row.id
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("预览")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "block" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            background: "",
                            "page-sizes": [10, 20, 30],
                            "page-size": _vm.tableForm.limit,
                            "current-page": _vm.tableForm.page,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.tableData.total,
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.pageChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.perViewDia.visible,
            title: "",
            width: "430px",
            top: "7vh",
            "destroy-on-close": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.perViewDia, "visible", $event)
            },
          },
        },
        [
          _vm.perViewDia.visible
            ? _c("iframe", {
                staticStyle: { width: "390px", height: "800px" },
                attrs: {
                  id: "ifPerviewShop",
                  src: _vm.perViewDia.perViewUrl,
                  frameborder: "0",
                },
              })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }